import { LatLngLiteral } from "@agm/core";

export const BAGCILAR_GEOPATHS: Array<LatLngLiteral> = 
[
    {
        lng: 28.8079843, lat: 41.0465023
    },
    {
        lng: 28.8079997, lat: 41.0462732
    },
    {
        lng: 28.8080338, lat: 41.0457893
    },
    {
        lng: 28.8082401, lat: 41.0445564
    },
    {
        lng: 28.8084386, lat: 41.0437748
    },
    {
        lng: 28.8087143, lat: 41.0428885
    },
    {
        lng: 28.809017, lat: 41.0421509
    },
    {
        lng: 28.8095512, lat: 41.0409571
    },
    {
        lng: 28.8101813, lat: 41.0394433
    },
    {
        lng: 28.8104713, lat: 41.0385977
    },
    {
        lng: 28.8107326, lat: 41.0375949
    },
    {
        lng: 28.8108393, lat: 41.036765
    },
    {
        lng: 28.8109024, lat: 41.0358575
    },
    {
        lng: 28.810882, lat: 41.0351066
    },
    {
        lng: 28.8107936, lat: 41.0339296
    },
    {
        lng: 28.810783, lat: 41.0318893
    },
    {
        lng: 28.8108055, lat: 41.0303425
    },
    {
        lng: 28.8108441, lat: 41.0291592
    },
    {
        lng: 28.8109991, lat: 41.027182
    },
    {
        lng: 28.8127862, lat: 41.0253659
    },
    {
        lng: 28.8131452, lat: 41.0251464
    },
    {
        lng: 28.8135334, lat: 41.0247555
    },
    {
        lng: 28.8139891, lat: 41.0243951
    },
    {
        lng: 28.8153903, lat: 41.0234229
    },
    {
        lng: 28.8159437, lat: 41.023157
    },
    {
        lng: 28.8170833, lat: 41.0227005
    },
    {
        lng: 28.8179082, lat: 41.0223796
    },
    {
        lng: 28.8188034, lat: 41.0219587
    },
    {
        lng: 28.8202135, lat: 41.0212587
    },
    {
        lng: 28.8211466, lat: 41.0206592
    },
    {
        lng: 28.8218895, lat: 41.0201273
    },
    {
        lng: 28.8224765, lat: 41.0198726
    },
    {
        lng: 28.8228604, lat: 41.0197781
    },
    {
        lng: 28.82359, lat: 41.0198566
    },
    {
        lng: 28.824036, lat: 41.0199873
    },
    {
        lng: 28.8254869, lat: 41.0203631
    },
    {
        lng: 28.8258441, lat: 41.020377
    },
    {
        lng: 28.8271045, lat: 41.0203317
    },
    {
        lng: 28.8271743, lat: 41.0205617
    },
    {
        lng: 28.8274375, lat: 41.0210778
    },
    {
        lng: 28.827943, lat: 41.0218934
    },
    {
        lng: 28.8281856, lat: 41.0221209
    },
    {
        lng: 28.8302246, lat: 41.0221338
    },
    {
        lng: 28.8313865, lat: 41.0222836
    },
    {
        lng: 28.8324026, lat: 41.022452
    },
    {
        lng: 28.8342091, lat: 41.022761
    },
    {
        lng: 28.8346468, lat: 41.0228827
    },
    {
        lng: 28.8351695, lat: 41.0230622
    },
    {
        lng: 28.8351912, lat: 41.0230284
    },
    {
        lng: 28.8361328, lat: 41.0232375
    },
    {
        lng: 28.8371276, lat: 41.0233822
    },
    {
        lng: 28.8379871, lat: 41.0236683
    },
    {
        lng: 28.8391601, lat: 41.0222932
    },
    {
        lng: 28.8393177, lat: 41.0220604
    },
    {
        lng: 28.8397369, lat: 41.0222787
    },
    {
        lng: 28.8401044, lat: 41.0220274
    },
    {
        lng: 28.8403691, lat: 41.0218843
    },
    {
        lng: 28.8414869, lat: 41.0214159
    },
    {
        lng: 28.8419606, lat: 41.0213539
    },
    {
        lng: 28.8422664, lat: 41.0213702
    },
    {
        lng: 28.8428892, lat: 41.0213938
    },
    {
        lng: 28.8437573, lat: 41.0214004
    },
    {
        lng: 28.8443264, lat: 41.0214024
    },
    {
        lng: 28.8445289, lat: 41.0216241
    },
    {
        lng: 28.8452308, lat: 41.0224199
    },
    {
        lng: 28.8456631, lat: 41.0228247
    },
    {
        lng: 28.8462511, lat: 41.0233099
    },
    {
        lng: 28.84706, lat: 41.0239595
    },
    {
        lng: 28.8471654, lat: 41.0240397
    },
    {
        lng: 28.8474295, lat: 41.0242114
    },
    {
        lng: 28.8475377, lat: 41.0242509
    },
    {
        lng: 28.847565, lat: 41.0241525
    },
    {
        lng: 28.8482941, lat: 41.022573
    },
    {
        lng: 28.8483571, lat: 41.0222437
    },
    {
        lng: 28.8484567, lat: 41.0214301
    },
    {
        lng: 28.8492124, lat: 41.0213606
    },
    {
        lng: 28.8499121, lat: 41.0212722
    },
    {
        lng: 28.8506599, lat: 41.0212483
    },
    {
        lng: 28.8508206, lat: 41.0212329
    },
    {
        lng: 28.8517819, lat: 41.0212093
    },
    {
        lng: 28.8524163, lat: 41.0212344
    },
    {
        lng: 28.8534729, lat: 41.021202
    },
    {
        lng: 28.853939, lat: 41.0211724
    },
    {
        lng: 28.8540926, lat: 41.021099
    },
    {
        lng: 28.8543987, lat: 41.021099
    },
    {
        lng: 28.8545948, lat: 41.0211241
    },
    {
        lng: 28.8551267, lat: 41.0209849
    },
    {
        lng: 28.8553145, lat: 41.020051
    },
    {
        lng: 28.8553828, lat: 41.0199506
    },
    {
        lng: 28.8559187, lat: 41.0197353
    },
    {
        lng: 28.856313, lat: 41.0196245
    },
    {
        lng: 28.8565747, lat: 41.0195337
    },
    {
        lng: 28.8568665, lat: 41.019476
    },
    {
        lng: 28.8584705, lat: 41.0191368
    },
    {
        lng: 28.8584013, lat: 41.0200373
    },
    {
        lng: 28.858435, lat: 41.0202588
    },
    {
        lng: 28.8588652, lat: 41.0198379
    },
    {
        lng: 28.8590478, lat: 41.0195895
    },
    {
        lng: 28.8594125, lat: 41.0190217
    },
    {
        lng: 28.8597269, lat: 41.018429
    },
    {
        lng: 28.8598295, lat: 41.0181548
    },
    {
        lng: 28.8599839, lat: 41.0179722
    },
    {
        lng: 28.8600445, lat: 41.0177221
    },
    {
        lng: 28.8601491, lat: 41.0175556
    },
    {
        lng: 28.8610387, lat: 41.018
    },
    {
        lng: 28.8627742, lat: 41.0188931
    },
    {
        lng: 28.8631331, lat: 41.0190518
    },
    {
        lng: 28.862329, lat: 41.0202141
    },
    {
        lng: 28.8621704, lat: 41.020468
    },
    {
        lng: 28.8624117, lat: 41.0205701
    },
    {
        lng: 28.8620609, lat: 41.021044
    },
    {
        lng: 28.8625304, lat: 41.021346
    },
    {
        lng: 28.8623724, lat: 41.021617
    },
    {
        lng: 28.8621373, lat: 41.0218696
    },
    {
        lng: 28.8615157, lat: 41.0223751
    },
    {
        lng: 28.8612556, lat: 41.0226334
    },
    {
        lng: 28.8608852, lat: 41.0230691
    },
    {
        lng: 28.86067, lat: 41.0233666
    },
    {
        lng: 28.8602909, lat: 41.024068
    },
    {
        lng: 28.8600951, lat: 41.0245512
    },
    {
        lng: 28.8598638, lat: 41.0251965
    },
    {
        lng: 28.8595031, lat: 41.0255852
    },
    {
        lng: 28.8594069, lat: 41.0258386
    },
    {
        lng: 28.8593247, lat: 41.0261648
    },
    {
        lng: 28.8591487, lat: 41.0267693
    },
    {
        lng: 28.8591122, lat: 41.0270487
    },
    {
        lng: 28.8590839, lat: 41.0274117
    },
    {
        lng: 28.8590372, lat: 41.0275909
    },
    {
        lng: 28.8595746, lat: 41.0277644
    },
    {
        lng: 28.8593879, lat: 41.0281251
    },
    {
        lng: 28.8590939, lat: 41.0287282
    },
    {
        lng: 28.8599337, lat: 41.0292347
    },
    {
        lng: 28.8609121, lat: 41.0294471
    },
    {
        lng: 28.8610242, lat: 41.0292181
    },
    {
        lng: 28.8616296, lat: 41.0293593
    },
    {
        lng: 28.8623106, lat: 41.0295424
    },
    {
        lng: 28.8630936, lat: 41.029813
    },
    {
        lng: 28.8632628, lat: 41.0295284
    },
    {
        lng: 28.8639439, lat: 41.0297441
    },
    {
        lng: 28.8642153, lat: 41.0296677
    },
    {
        lng: 28.8646289, lat: 41.0295741
    },
    {
        lng: 28.8648455, lat: 41.029518
    },
    {
        lng: 28.8650448, lat: 41.0294862
    },
    {
        lng: 28.8652137, lat: 41.029476
    },
    {
        lng: 28.8671415, lat: 41.0294713
    },
    {
        lng: 28.8673364, lat: 41.0294879
    },
    {
        lng: 28.8677986, lat: 41.0294369
    },
    {
        lng: 28.868496, lat: 41.029314
    },
    {
        lng: 28.8687135, lat: 41.0292462
    },
    {
        lng: 28.8691808, lat: 41.0291318
    },
    {
        lng: 28.8694928, lat: 41.0289045
    },
    {
        lng: 28.8698129, lat: 41.0286994
    },
    {
        lng: 28.870851, lat: 41.0279502
    },
    {
        lng: 28.8709919, lat: 41.0278973
    },
    {
        lng: 28.8714234, lat: 41.0278076
    },
    {
        lng: 28.871695, lat: 41.0277845
    },
    {
        lng: 28.872314, lat: 41.0276721
    },
    {
        lng: 28.8725917, lat: 41.027944
    },
    {
        lng: 28.872744, lat: 41.0284118
    },
    {
        lng: 28.8727421, lat: 41.0286774
    },
    {
        lng: 28.872651, lat: 41.0294059
    },
    {
        lng: 28.8725401, lat: 41.0301578
    },
    {
        lng: 28.8723218, lat: 41.0315778
    },
    {
        lng: 28.8715746, lat: 41.0339125
    },
    {
        lng: 28.8714824, lat: 41.0347326
    },
    {
        lng: 28.8713845, lat: 41.0361405
    },
    {
        lng: 28.8713885, lat: 41.0365264
    },
    {
        lng: 28.8714381, lat: 41.0369957
    },
    {
        lng: 28.8713451, lat: 41.0374721
    },
    {
        lng: 28.8712411, lat: 41.0380047
    },
    {
        lng: 28.8712413, lat: 41.0382662
    },
    {
        lng: 28.8712219, lat: 41.0384458
    },
    {
        lng: 28.8712204, lat: 41.0384465
    },
    {
        lng: 28.8696298, lat: 41.0384657
    },
    {
        lng: 28.8687968, lat: 41.0385033
    },
    {
        lng: 28.8683683, lat: 41.0385773
    },
    {
        lng: 28.8681584, lat: 41.0386214
    },
    {
        lng: 28.8676331, lat: 41.0387814
    },
    {
        lng: 28.8663744, lat: 41.0392505
    },
    {
        lng: 28.8659561, lat: 41.039336
    },
    {
        lng: 28.8650537, lat: 41.0394626
    },
    {
        lng: 28.8644997, lat: 41.0395605
    },
    {
        lng: 28.8639076, lat: 41.039691
    },
    {
        lng: 28.8616093, lat: 41.0401794
    },
    {
        lng: 28.8615091, lat: 41.0402083
    },
    {
        lng: 28.8611078, lat: 41.040265
    },
    {
        lng: 28.8609331, lat: 41.0407575
    },
    {
        lng: 28.8606644, lat: 41.04134
    },
    {
        lng: 28.8606055, lat: 41.0415006
    },
    {
        lng: 28.8605086, lat: 41.0417678
    },
    {
        lng: 28.8601607, lat: 41.0427498
    },
    {
        lng: 28.8599608, lat: 41.0427206
    },
    {
        lng: 28.8593461, lat: 41.0427262
    },
    {
        lng: 28.8593923, lat: 41.0430823
    },
    {
        lng: 28.8594421, lat: 41.043298
    },
    {
        lng: 28.859461, lat: 41.0433761
    },
    {
        lng: 28.8596875, lat: 41.0443115
    },
    {
        lng: 28.8597839, lat: 41.0447749
    },
    {
        lng: 28.859792, lat: 41.0451607
    },
    {
        lng: 28.859842, lat: 41.0463967
    },
    {
        lng: 28.8599491, lat: 41.0480885
    },
    {
        lng: 28.8599313, lat: 41.0483265
    },
    {
        lng: 28.8599172, lat: 41.0483761
    },
    {
        lng: 28.8598474, lat: 41.048597
    },
    {
        lng: 28.8597098, lat: 41.0488814
    },
    {
        lng: 28.8590224, lat: 41.0499926
    },
    {
        lng: 28.8588322, lat: 41.0503593
    },
    {
        lng: 28.857684, lat: 41.052484
    },
    {
        lng: 28.8575219, lat: 41.0527012
    },
    {
        lng: 28.8570153, lat: 41.0534988
    },
    {
        lng: 28.8566528, lat: 41.0540765
    },
    {
        lng: 28.8564667, lat: 41.0540888
    },
    {
        lng: 28.8557336, lat: 41.0541373
    },
    {
        lng: 28.8547557, lat: 41.0543062
    },
    {
        lng: 28.8549241, lat: 41.0549502
    },
    {
        lng: 28.8550903, lat: 41.0555859
    },
    {
        lng: 28.8552083, lat: 41.0556928
    },
    {
        lng: 28.8553792, lat: 41.0562552
    },
    {
        lng: 28.8552646, lat: 41.056677
    },
    {
        lng: 28.8549818, lat: 41.0574019
    },
    {
        lng: 28.8548981, lat: 41.0581482
    },
    {
        lng: 28.8547991, lat: 41.0595668
    },
    {
        lng: 28.8547578, lat: 41.0603354
    },
    {
        lng: 28.8548048, lat: 41.0608594
    },
    {
        lng: 28.8548686, lat: 41.0616612
    },
    {
        lng: 28.8549333, lat: 41.0622472
    },
    {
        lng: 28.8550107, lat: 41.0625449
    },
    {
        lng: 28.8551542, lat: 41.062954
    },
    {
        lng: 28.855463, lat: 41.0635972
    },
    {
        lng: 28.8557817, lat: 41.0645084
    },
    {
        lng: 28.8558382, lat: 41.0646845
    },
    {
        lng: 28.8558815, lat: 41.0647978
    },
    {
        lng: 28.8560133, lat: 41.0651756
    },
    {
        lng: 28.8563009, lat: 41.0657121
    },
    {
        lng: 28.8562603, lat: 41.0657761
    },
    {
        lng: 28.8563539, lat: 41.0658832
    },
    {
        lng: 28.8565435, lat: 41.0661785
    },
    {
        lng: 28.8565699, lat: 41.0663629
    },
    {
        lng: 28.8565352, lat: 41.0665851
    },
    {
        lng: 28.8563007, lat: 41.0669774
    },
    {
        lng: 28.8573451, lat: 41.0673129
    },
    {
        lng: 28.8576961, lat: 41.0678175
    },
    {
        lng: 28.8581617, lat: 41.0684949
    },
    {
        lng: 28.8587605, lat: 41.0692924
    },
    {
        lng: 28.8594047, lat: 41.0701335
    },
    {
        lng: 28.8602278, lat: 41.0712191
    },
    {
        lng: 28.8602661, lat: 41.0714138
    },
    {
        lng: 28.8589577, lat: 41.0717867
    },
    {
        lng: 28.8577878, lat: 41.0720924
    },
    {
        lng: 28.8576427, lat: 41.0721269
    },
    {
        lng: 28.8568034, lat: 41.0721396
    },
    {
        lng: 28.856063, lat: 41.0719754
    },
    {
        lng: 28.855946, lat: 41.0724184
    },
    {
        lng: 28.8540652, lat: 41.0722428
    },
    {
        lng: 28.8537226, lat: 41.0721677
    },
    {
        lng: 28.8529714, lat: 41.0717347
    },
    {
        lng: 28.851625, lat: 41.0702603
    },
    {
        lng: 28.8504788, lat: 41.0691237
    },
    {
        lng: 28.8489224, lat: 41.067628
    },
    {
        lng: 28.8483361, lat: 41.0671384
    },
    {
        lng: 28.8472559, lat: 41.0662364
    },
    {
        lng: 28.8467462, lat: 41.0658859
    },
    {
        lng: 28.8459053, lat: 41.0654981
    },
    {
        lng: 28.844779, lat: 41.0651785
    },
    {
        lng: 28.8435746, lat: 41.0650259
    },
    {
        lng: 28.8423649, lat: 41.0650787
    },
    {
        lng: 28.8414463, lat: 41.0652347
    },
    {
        lng: 28.8406309, lat: 41.0654647
    },
    {
        lng: 28.8397003, lat: 41.0658698
    },
    {
        lng: 28.838239, lat: 41.0668532
    },
    {
        lng: 28.8369195, lat: 41.0676903
    },
    {
        lng: 28.835711, lat: 41.0682022
    },
    {
        lng: 28.8337771, lat: 41.0688498
    },
    {
        lng: 28.8313128, lat: 41.0697286
    },
    {
        lng: 28.8306163, lat: 41.0699665
    },
    {
        lng: 28.8299951, lat: 41.0701073
    },
    {
        lng: 28.8285602, lat: 41.0703147
    },
    {
        lng: 28.8277672, lat: 41.0703311
    },
    {
        lng: 28.8263225, lat: 41.0702732
    },
    {
        lng: 28.8246747, lat: 41.0702489
    },
    {
        lng: 28.823508, lat: 41.0702904
    },
    {
        lng: 28.8219872, lat: 41.0705529
    },
    {
        lng: 28.8207322, lat: 41.0708753
    },
    {
        lng: 28.8183898, lat: 41.0714217
    },
    {
        lng: 28.8160019, lat: 41.0720065
    },
    {
        lng: 28.8153931, lat: 41.0722211
    },
    {
        lng: 28.8148433, lat: 41.0712382
    },
    {
        lng: 28.8143868, lat: 41.0703541
    },
    {
        lng: 28.8138662, lat: 41.0694915
    },
    {
        lng: 28.8134752, lat: 41.0686836
    },
    {
        lng: 28.8135025, lat: 41.0682004
    },
    {
        lng: 28.8135697, lat: 41.0677531
    },
    {
        lng: 28.8137843, lat: 41.0671991
    },
    {
        lng: 28.8138096, lat: 41.0662782
    },
    {
        lng: 28.8137784, lat: 41.0654474
    },
    {
        lng: 28.812171, lat: 41.0632705
    },
    {
        lng: 28.8119511, lat: 41.0628687
    },
    {
        lng: 28.8116866, lat: 41.0622162
    },
    {
        lng: 28.8116116, lat: 41.061291
    },
    {
        lng: 28.8114533, lat: 41.0604736
    },
    {
        lng: 28.8110903, lat: 41.0594089
    },
    {
        lng: 28.8107594, lat: 41.0582527
    },
    {
        lng: 28.8103753, lat: 41.056632
    },
    {
        lng: 28.8100267, lat: 41.0552832
    },
    {
        lng: 28.8095649, lat: 41.0536926
    },
    {
        lng: 28.809091, lat: 41.0520626
    },
    {
        lng: 28.8088236, lat: 41.0511162
    },
    {
        lng: 28.8084434, lat: 41.0497337
    },
    {
        lng: 28.8081767, lat: 41.0485562
    },
    {
        lng: 28.808126, lat: 41.0482755
    },
    {
        lng: 28.8080856, lat: 41.0480141
    },
    {
        lng: 28.808028, lat: 41.0475331
    },
    {
        lng: 28.8080046, lat: 41.0472118
    },
    {
        lng: 28.8079843, lat: 41.0465023
    }
]


// WEBPACK FOOTER //
// ./src/_models/bagcilar.ts